// test/list.js
import { PageContainer } from '@ant-design/pro-layout'

function TestListPage() {
    return (
        <PageContainer
            header={{
                title: 'Edit Test',
            }}
        >
            edit
        </PageContainer>
    )
}


export default TestListPage;